module.exports = __webpack_public_path__ + "static/img/science-in-hd-ooNO0LlxZRM-unsplash.fdc5a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/science-in-hd-ooNO0LlxZRM-unsplash.png
// module id = Uh+X
// module chunks = 0